export default __webpack_public_path__ + "static/media/LEGA9030.23ad5b67.jpg";